import React from 'react';
import CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';
import useCustomFields from '@/lib/hooks/swr/useCustomFields';
import { type FilterParams } from '@/modules/QueryProvider';

/**
 * This takes a filterParams object for use with the QueryProvider and adds
 * parameters for controlling custom field values.
 */
const useCustomFieldsWithFilterParams = (filterParams: FilterParams) => {
  const { data: customFields } = useCustomFields();

  const paramsWithCustomFields = React.useMemo(
    () =>
      customFields
        ? customFields.reduce((obj, field) => {
            switch (field.fieldType) {
              case CustomFieldTypes.CHECKBOX:
                return {
                  ...obj,
                  [field.slug]: {
                    type: Boolean,
                    defaultValue: null,
                  },
                };
              case CustomFieldTypes.DATE_PICKER:
                return {
                  ...obj,
                  [field.slug]: {
                    type: Date,
                    defaultValue: null,
                  },
                };
              case CustomFieldTypes.LIST_SINGLE:
                return {
                  ...obj,
                  [field.slug]: {
                    type: String,
                    defaultValue: null,
                  },
                };
              case CustomFieldTypes.LIST_MULTI:
                return {
                  ...obj,
                  [field.slug]: {
                    type: Array,
                    defaultValue: [],
                  },
                };
              default:
                return obj;
            }
          }, filterParams)
        : filterParams,
    [customFields, filterParams],
  );

  return paramsWithCustomFields;
};

export default useCustomFieldsWithFilterParams;
